/** URL `?tab=` に載せるタブの識別子。並びは画面に出す順。 */
export type DemandSettingsTabKey = 'demand-groups' | 'breakdown-mode'

/**
 * タブの公開 flag を運ぶ query の状態。`enabled` / `disabled` は取得できた flag の値。
 * 取得中は `loading`、flag を取れずに失敗した時は `error`。
 */
export type TabAvailability = 'loading' | 'error' | 'enabled' | 'disabled'

/**
 * flag を `featureEnabled` で返す query (目録・想定モード一覧) の状態を写す。
 * 一度取得できていれば、その後の再取得が失敗しても取得済みの flag で判定する
 * (タブを出したまま、タブの中で取得失敗を知らせる)。
 */
export function tabAvailability(query: {
  data: { featureEnabled: boolean } | undefined
  isError: boolean
}): TabAvailability {
  if (query.data !== undefined) {
    return query.data.featureEnabled ? 'enabled' : 'disabled'
  }
  return query.isError ? 'error' : 'loading'
}

/**
 * 出せるタブ。`null` はまだ決められない (どちらかの flag を取得中) ことを表す。
 *
 * 需要グループの取得失敗はタブを出してタブの中で知らせる (AC-CDG-034)。想定モードの取得失敗は
 * 公開の有無が分からないので、出さない側に倒す (未公開の組織に出さない。AC-6)。
 */
export function availableDemandSettingsTabs(flags: {
  demandGroups: TabAvailability
  breakdownModes: TabAvailability
}): DemandSettingsTabKey[] | null {
  if (flags.demandGroups === 'loading' || flags.breakdownModes === 'loading') {
    return null
  }
  // 並びは React mock の設定タブ (AdminDemandGroups の SETTING_TABS) に合わせ、想定モードを先に置く
  const tabs: DemandSettingsTabKey[] = []
  if (flags.breakdownModes === 'enabled') {
    tabs.push('breakdown-mode')
  }
  if (flags.demandGroups === 'enabled' || flags.demandGroups === 'error') {
    tabs.push('demand-groups')
  }
  return tabs
}
